<template>
    <b-table
        id="procuradores"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive="sm"
        :no-local-sorting="true"
        @sort-changed="sortingChanged"
        :busy="configTable.load"
        show-empty
        > 
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum procurador encontrado.</p>
        </template>
        <template slot="HEAD_selecionar">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template slot="selecionar" slot-scope="row">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(row.item)" @change="toggleCheck($event, row.item)" />
        </template>
        <template slot="1" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.nome }} </p>
        </template>
        <template slot="2" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.cpf | cpfCnpj }} </p>
        </template>
        <template slot="3" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.numeroOab }} </p>
        </template>
        <template slot="4" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.ufOAB ? row.item.ufOAB.sigla : '' }} </p>
        </template>
        <template slot="5" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.codProcuradorSPJ }} </p>
        </template>
        <template slot="6" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.email }} </p>
        </template>
        <template slot="7" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.usuarioAlteracao ? row.item.usuarioAlteracao.nomeUsuario : '' }} </p>
        </template>
        <template slot="8" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.dataInclusao }} </p>
        </template>
        <template slot="9" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.indAtivo ? 'Ativo' : 'Inativo' }} </p>
        </template>
    </b-table>
</template>

<script>
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultar')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el)
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item)
            } else {
                item.checked = checked
                const index = this.selecteds.indexOf(item)
                this.selecteds.splice(index, 1)
                this.configTable.checkedAll = false
            }

        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'nome'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'cpf'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'numeroOAB'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'ufOAB'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'codProcuradorSPJ'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'email'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'usuarioAlteracao'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'dataInclusao'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'ativo'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
